import { useAuth } from './AuthContext';
import { API_BASE_URL } from '../../config/api';

function LoginButton() {
  const { user, isAuthenticated } = useAuth();
  const isLocalhost = window.location.hostname === 'localhost' && window.location.port === '5173';

  const handleLogin = () => {
    window.location.href = `${API_BASE_URL}/auth/google`;
  };

  const handleDevBypass = () => {
    window.location.href = `${API_BASE_URL}/auth/dev-bypass`;
  };

  const handleLogout = () => {
    window.location.href = `${API_BASE_URL}/auth/logout`;
  };

  if (isAuthenticated) {
    return (
      <div className="flex items-center gap-3">
        <img 
          src={user.picture} 
          alt="Profile" 
          className="w-8 h-8 rounded-full border border-gray-200"
        />
        <button
          onClick={handleLogout}
          className="text-gray-600 hover:text-gray-900 text-sm font-medium font-space"
        >
          Logout
        </button>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={handleLogin}
        className="text-gray-600 hover:text-gray-900 text-sm font-medium font-space"
      >
        Login
      </button>
      {isLocalhost && (
        <button
          onClick={handleDevBypass}
          className="text-green-600 hover:text-green-700 text-sm font-medium font-space border border-green-300 px-2 py-1 rounded text-xs"
        >
          Dev
        </button>
      )}
    </div>
  );
}

export default LoginButton; 